import { css, Theme } from '@emotion/react'

export const title = (theme: Theme) => css`
  font-weight: 400;
  color: ${theme.typographyColors.typographyThree};
`

export const tabs = (theme: Theme) => css`
  margin: ${theme.spacing(1.25, 0, 3)};
`
